import axios from "axios";
import { baseUrl, config, requestID } from "../common/utils";
import { Vendor, VendorProcedure } from "../models/vendor";

export const getVendors = async (payload?: any) => {
    const data = {
        requestID: requestID(),
        ...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "Geacloud_VendorManagements/getAllVendors",
            data,
            config
        );
        console.log("vendors", response);
        return response.data;
    } catch (error: any) {
        return error;
    }
};
export const getAllApprovedVendors = async () => {
    const data = {
        requestID: requestID(),
        // ...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "Geacloud_VendorManagements/getAllApprovedVendors",
            data,
            config
        );
        console.log("approved vendors", response);
        return response.data;
    } catch (error: any) {
        return error;
    }
};

export const getVendor = async (id: string) => {
    const data = {
        requestID: requestID(),
        vendor_id: id
    };
    try {
        const response = await axios.post(
            baseUrl() + "Geacloud_VendorManagements/getVendorById",
            data,
            config
        );
        console.log({ response });
        return response.data;
    } catch (error: any) {
        return error;
    }
};

export const updateVendorTaxes = async (payload: any) => {
    const data = {
        requestID: requestID(), 
        
        ...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "Geacloud_VendorManagements/updateVendorTaxes",
            data,
            config
        );
        console.log({ response });
        return response.data;
    } catch (error: any) {
        return error;
    }
};

export const getVendorProcedures = async (vendorId: string) => {
    const data = {
        requestID: requestID(),
        vendor_id: vendorId
    };
    try {
        const response = await axios.post(
            baseUrl() + "Geacloud_VendorManagements/getVendorProcedures",
            data,
            config
        );
        console.log("vendor procedures", response);
        return response.data;
    } catch (error: any) {
        return error;
    }
};

export const saveVendorProcedures = async (payload: any) => {
    const data = {
        requestID: requestID(),
        ...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "Geacloud_VendorManagements/saveVendorProcedures",
            data,
            config
        );
        console.log({ response });
        return response.data;
    } catch (error: any) {
        return error;
    }
};

export const updateVendorStatus = async (vendorId: string, action: string) => {
    const data = {
        requestID: requestID(),
        vendor_id: vendorId,
        action: action
    };
    try {
        const response = await axios.post(
            baseUrl() + "Geacloud_VendorManagements/updateVendorStatus",
            data,
            config
        );
        console.log({ response });
        return response.data;
    } catch (error: any) {
        return error;
    }
};
